import ProvidentFundReportView from '../../components/ProvidentFundReportView';
export default function RegionPolicyReport(){return <ProvidentFundReportView key="region" reportKind="region"/>;}
